<template>
    <div class='features-intro'>
        <template v-for="feature in featuresList">
            <feature-intro
                :class='feature.type'
                :key="feature.type"
                :props="feature"
            >
                <template v-slot:slot-pc-image>
                    <img
                        v-if="hasImage(feature)"
                        :src="feature.image.pcImageSrc"
                    />
                    <video
                        v-else
                        :src='feature.video.src'
                        :poster="feature.video.poster"
                        class='richNotification-video'
                        id='richNotification-video'
                        muted
                        autoplay>
                    </video>
                </template>
                <template v-slot:slot-mobile-image>
                    <img
                        v-if="hasImage(feature)"
                        :src="feature.image.mobileImageSrc"
                    />
                    <video
                        v-else
                        :src='feature.video.src'
                        :poster="feature.video.poster"
                        class='richNotification-video'
                        id='richNotification-video'
                        muted
                        autoplay>
                    </video>
                </template>
            </feature-intro>
        </template>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import FeatureIntro from './FeatureIntroItem.vue';
import { TFeatureIntroduction, IFeatureIntroductionWithImage } from './../lib';

export default Vue.extend({
    components: {
        FeatureIntro
    },
    props: {
        featuresList: Array as PropType<TFeatureIntroduction[]>
    },
    data() {

        return {

        };

    },
    methods: {
        hasImage( feature: TFeatureIntroduction ): feature is IFeatureIntroductionWithImage {

            return ['video-record', 'privacy'].includes( feature.type );

        }
    }

});
</script>
